module.exports = __webpack_public_path__ + "assets/documentation.250402ca.svg";